export const FORGOT_PASSWORD_URL = "/forgot-password"